module.exports = __webpack_public_path__ + "img/Comic02-3.52709a9d.png";